export default __webpack_public_path__ + "static/media/collectiveImage.58e019a9.jpg";